import {MonitoringService} from './../../monitoring.service';
import {ChangeDetectionStrategy, Component, ElementRef, viewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {filterNulls, TranslatePipe} from '@brunata-angular/util';
import {CommonModule} from '@angular/common';
import {DateTimePipe} from '@brunata-angular/ui';
import {EmailLogData} from './email-log-data.model';
import {BehaviorSubject, Observable, switchMap, tap} from 'rxjs';

@Component({
    selector: 'app-notification-details-modal',
    templateUrl: './notification-details-modal.component.html',
    styleUrl: './notification-details-modal.component.scss',
    imports: [TranslatePipe, CommonModule, DateTimePipe],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationDetailsModalComponent {
    readonly emailLogId: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
    private readonly iframe = viewChild.required<ElementRef<HTMLIFrameElement>>('iframe');
    view$: Observable<EmailLogData> = this.emailLogId.pipe(
        filterNulls(),
        switchMap(id =>
            this.monitoringService.getEmailLog(id).pipe(
                tap(data => {
                    if (data.htmlContent != null) {
                        this.iframe().nativeElement.contentDocument?.write(data.htmlContent);
                    }
                }),
            ),
        ),
    );
    constructor(
        public activeModal: NgbActiveModal,
        private monitoringService: MonitoringService,
    ) {}
}
